import { render, staticRenderFns } from "./addReportCustomComponentRel.vue?vue&type=template&id=6f0c816c&scoped=true"
import script from "./addReportCustomComponentRel.vue?vue&type=script&lang=js"
export * from "./addReportCustomComponentRel.vue?vue&type=script&lang=js"
import style0 from "./addReportCustomComponentRel.vue?vue&type=style&index=0&id=6f0c816c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c816c",
  null
  
)

export default component.exports